class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
/* Ban-91: the cart-count refresh that was here is gone: global.js had the same code, so every page asked /cart.js 2-4 times
   (measured 19/10 on TEST 9/10). global.js keeps one request per page view (see Ban-91 there). */
/* Ban-78: the Searchanise search box code (suggestions from searchanise.com, the "Trending / Recent searches" lists
   and the jump to /pages/search-results-page) is gone: search now uses Shopify's own search, see assets/ez-search.js.
   Kept from that block: the product page's "Preview" button shown once the gallery is scrolled past (phones). */
/* Ban-91: the same show / hide, without measuring the page on every scroll event. Before: each scroll event read the
   gallery's position and height (offset() + height() force a layout) and called fadeIn / fadeOut, 60+ times a second while a
   phone scrolls (1.1 ms per event on a desktop PC, max 5 ms; a mid phone ~4x). Now the bottom of the gallery is measured only
   when something changes size (ResizeObserver), scrolling compares two numbers once per frame, and the bar fades only when
   the state changes. Rule unchanged: phones / tablets (width <= 1024), bar shown once the gallery's bottom is 150 px above
   the bottom of the screen. */
(function () {
  function init() {
    var target = document.querySelector('.grid__item.product__media-wrapper');
    if (!target || !document.querySelector('.btn-preview')) return;
    var galleryBottom = Infinity, shown = null, queued = false;
    function measure() {
      var r = target.getBoundingClientRect();
      galleryBottom = r.top + (window.pageYOffset || document.documentElement.scrollTop) + r.height;
      if (shown !== null) queue();   /* like before, nothing changes until the first scroll */
    }
    function sync() {
      queued = false;
      if (window.innerWidth > 1024) return;
      var y = window.pageYOffset || document.documentElement.scrollTop;
      var on = y + window.innerHeight - 150 >= galleryBottom;
      if (on === shown) return;
      shown = on;
      var $bar = $('.btn-preview');
      if (on) { $bar.stop(true, true).fadeIn(); $bar.removeClass('hidden'); }
      else { $bar.stop(true, true).fadeOut(); $bar.addClass('hidden'); }
    }
    function queue() { if (!queued) { queued = true; requestAnimationFrame(sync); } }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(measure);
      ro.observe(target);
      ro.observe(document.body);
    } else {
      window.addEventListener('resize', measure);
    }
    window.addEventListener('scroll', queue, { passive: true });
    measure();
  }
  $(init);
})();
